const rowEqual = (a, b) =>
  a.drugName === b.drugName &&
  a.manufacturer === b.manufacturer &&
  a.strength === b.strength &&
  a.ndc === b.ndc &&
  a.lotNumber === b.lotNumber;

// True when two inventory-listing row arrays carry the same data in the same
// order — the scan app re-parses the same CSV deterministically, so ordering
// is stable when nothing changed. Used to skip a state update (and the
// re-render it would trigger) when a periodic inventory push repeats data
// the portal already has.
const inventoryRowsEqual = (a, b) => {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
  return a.every((row, i) => rowEqual(row, b[i]));
};

export default inventoryRowsEqual;
